import styles from './Map.module.scss';
import type { MapPalette, MapStyleTokens } from './map.types';

/**
 * Palettes are static: `styles` from the CSS module is resolved at build time.
 */
export const MAP_PALETTES: Partial<Record<MapStyleTokens, MapPalette>> = {
  dark: {
    background: styles.overlayBackground,
    surfaceSubtle: styles.overlaySurfaceSubtle,
    surfaceMuted: styles.overlaySurfaceMuted,
    water: styles.overlayWater,
    textPrimary: styles.overlayTextPrimary,
    textSecondary: styles.overlayTextSecondary,
    road: styles.overlayRoad,
    roadHighway: styles.overlayRoadHighway,
    transit: styles.overlayTransit,
    transitStation: styles.overlayTransitStation,
    park: styles.overlayPark,
    parkText: styles.overlayParkText,
    poi: styles.overlayPoi,
    poiText: styles.overlayPoiText,
    landParcelText: styles.overlayLandParcelText,
    markerTitle: styles.overlayMarkerTitle,
    tooltipText: styles.overlayTooltipText,
    tooltipBackground: styles.overlayTooltipBackground,
    tooltipBorder: styles.overlayTooltipBorder,
    tooltipBorderRadius: styles.overlayTooltipBorderRadius,
  },
  gray: {
    background: styles.background,
    surfaceSubtle: styles.surfaceSubtle,
    surfaceMuted: styles.surfaceMuted,
    water: styles.water,
    textPrimary: styles.textPrimary,
    textSecondary: styles.textSecondary,
    road: styles.road,
    roadHighway: styles.roadHighway,
    transit: styles.transit,
    transitStation: styles.transitStation,
    park: styles.park,
    parkText: styles.parkText,
    poi: styles.poi,
    poiText: styles.poiText,
    landParcelText: styles.landParcelText,
    markerTitle: styles.markerTitle,
    tooltipText: styles.tooltipText,
    tooltipBackground: styles.tooltipBackground,
    tooltipBorder: styles.tooltipBorder,
    tooltipBorderRadius: styles.tooltipBorderRadius,
  },
  brand: {
    background: styles.brandBackground,
    surfaceSubtle: styles.brandSurfaceSubtle,
    surfaceMuted: styles.brandSurfaceMuted,
    water: styles.brandWater,
    textPrimary: styles.brandTextPrimary,
    textSecondary: styles.brandTextSecondary,
    road: styles.brandRoad,
    roadHighway: styles.brandRoadHighway,
    transit: styles.brandTransit,
    transitStation: styles.brandTransitStation,
    park: styles.brandPark,
    parkText: styles.brandParkText,
    poi: styles.brandPoi,
    poiText: styles.brandPoiText,
    landParcelText: styles.brandLandParcelText,
    markerTitle: styles.brandMarkerTitle,
    tooltipText: styles.brandTooltipText,
    tooltipBackground: styles.brandTooltipBackground,
    tooltipBorder: styles.brandTooltipBorder,
    tooltipBorderRadius: styles.brandTooltipBorderRadius,
  },
  inverted: {
    background: styles.invertedBackground,
    surfaceSubtle: styles.invertedSurfaceSubtle,
    surfaceMuted: styles.invertedSurfaceMuted,
    water: styles.invertedWater,
    textPrimary: styles.invertedTextPrimary,
    textSecondary: styles.invertedTextSecondary,
    road: styles.invertedRoad,
    roadHighway: styles.invertedRoadHighway,
    transit: styles.invertedTransit,
    transitStation: styles.invertedTransitStation,
    park: styles.invertedPark,
    parkText: styles.invertedParkText,
    poi: styles.invertedPoi,
    poiText: styles.invertedPoiText,
    landParcelText: styles.invertedLandParcelText,
    markerTitle: styles.invertedMarkerTitle,
    tooltipText: styles.invertedTooltipText,
    tooltipBackground: styles.invertedTooltipBackground,
    tooltipBorder: styles.invertedTooltipBorder,
    tooltipBorderRadius: styles.invertedTooltipBorderRadius,
  },
};

export const resolveMapPalette = (token: MapStyleTokens): MapPalette =>
  token === 'default'
    ? MAP_PALETTES.inverted!
    : MAP_PALETTES[token] ?? MAP_PALETTES.brand ?? MAP_PALETTES.gray!;
